// pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import pattern1 from '../images/bengali-pattern1.jpg';
import pattern2 from '../images/bengali-border1.png';

const NotFound = () => {
    return (
        <div className="container" style={{ textAlign: 'center', padding: '4rem 1rem' }}>
            <div style={{
                position: 'relative',
                margin: '0 auto',
                maxWidth: '500px',
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '3rem 2rem 2rem',
                boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden'
            }}>
                {/* Decorative top border */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '5px',
                    background: 'linear-gradient(to right, var(--primary-color), var(--secondary-color), var(--accent-color))'
                }}></div>

                {/* Decorative pattern */}
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '80px',
                    height: '80px',
                    backgroundImage: pattern2,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.1
                }}></div>

                {/* 404 number with artistic styling */}
                <h1 style={{
                    fontSize: '6rem',
                    color: 'var(--primary-color)',
                    margin: '0 0 1rem',
                    fontFamily: 'var(--font-primary)',
                    position: 'relative',
                    display: 'inline-block'
                }}>
                    404
                    <span style={{
                        position: 'absolute',
                        bottom: '15px',
                        right: '-15px',
                        fontSize: '1.5rem',
                        color: 'var(--secondary-color)'
                    }}>
                        <i className="fas fa-palette"></i>
                    </span>
                </h1>

                <h2 style={{
                    fontSize: '1.8rem',
                    color: 'var(--accent-color)',
                    marginBottom: '1.5rem',
                    fontFamily: 'var(--font-primary)'
                }}>
                    Artistic Journey Interrupted
                </h2>

                <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
                    The masterpiece you're looking for seems to have wandered off the canvas. Let's guide you back to the gallery.
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <Link to="/" className="btn" style={{
                        backgroundColor: 'var(--primary-color)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}>
                        <i className="fas fa-home"></i> Return to Gallery
                    </Link>

                    <Link to="/gallery" className="btn" style={{
                        backgroundColor: 'transparent',
                        color: 'var(--primary-color)',
                        border: '1px solid var(--primary-color)'
                    }}>
                        Browse Artworks
                    </Link>
                </div>

                {/* Decorative pattern bottom */}
                <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '20px',
                    width: '60px',
                    height: '60px',
                    backgroundImage: pattern1,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.1
                }}></div>
            </div>

            {/* Art-themed 404 illustration */}
            <div style={{
                marginTop: '3rem',
                fontSize: '1.1rem',
                color: 'var(--accent-color)',
                opacity: 0.8
            }}>
                <i className="fas fa-paint-brush" style={{ marginRight: '0.5rem' }}></i>
                "In art, as in life, not all paths lead to a destination, but they all offer a journey."
            </div>
        </div>
    );
};

export default NotFound;